module.exports = __webpack_public_path__ + "static/media/tsb12ru.95c9817e.pdf";